// extracted by mini-css-extract-plugin
export default {"header":"dashboard_header__YlJax","layout":"dashboard_layout__8Z1Sb","layoutCollapsed":"dashboard_layoutCollapsed__bU839"};